import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ipm-mp3-license',
  templateUrl: './mp3-license.component.html',
  styleUrls: ['./mp3-license.component.scss']
})
export class Mp3LicenseComponent {
  @Input() CurrentLicenseData: any;
  currentLicense:any = '';
  currentData:any = '';
  currentDate:any = new Date();
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['CurrentLicenseData']) {
        this.currentData = this.CurrentLicenseData;
        let priceArray: any = this.currentData?.currentBeatData?.prices;
        let found =  priceArray.find((item: any) => item.licence === this.currentData?.cartData?.beat_price?.licence?._id)
        if (found) {
          this.currentLicense = found;
        }  
      }
  }
}
